"use client";

import type { CanvasSettingType } from "@tosize/panel-visualisation/src/CanvasSettings";
import type { EdgeBand, ProductionUnit } from "@tosize/ui";
import { type Dispatch, type SetStateAction, createContext, useContext } from "react";
import type { Workpiece } from "../lib/workpiece";

export interface PostData {
	product?: string;
	sku?: string;
	unit?: ProductionUnit;
	quantity: number;
}

export interface PostDataContextValue {
	defaultData: PostData;
	data: PostData;
	setData: Dispatch<SetStateAction<PostData>>;

	defaultWorkpiece: Workpiece;
	workpiece: Workpiece;
	setWorkpiece: Dispatch<SetStateAction<Workpiece>>;

	finishSwitchChecked: boolean;
	setFinishSwitchChecked: Dispatch<SetStateAction<boolean>>;

	canvasSettings?: CanvasSettingType;
	setCanvasSettings: Dispatch<SetStateAction<CanvasSettingType | undefined>>;
	onFinishSwitchCheckedChange: (checked: boolean) => void;

	selectedBand?: EdgeBand;
	setSelectedBand: Dispatch<SetStateAction<EdgeBand | undefined>>;
}

export const defaultWorkpiece: Workpiece = {
	shape: "plate_rectangle_custom",
	label: "",
	shape_dimensions: {},
	finishes: {
		side: {},
	},
	accepted_condition: false,
	version: 7,
};

export const defaultData: PostData = {
	product: undefined,
	sku: undefined,
	unit: undefined,
	quantity: 1,
};

export const PostDataContext = createContext<PostDataContextValue>({
	data: defaultData,
} as PostDataContextValue);

export function usePostDataContext() {
	const context = useContext(PostDataContext);

	if (context === null) throw new Error("PostDataContext is not available");

	return context;
}
